import { render } from "./PercentageBar.vue?vue&type=template&id=5b03e7bd&scoped=true"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"

import "./PercentageBar.vue?vue&type=style&index=0&id=5b03e7bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b03e7bd"]])

export default __exports__